// NOTE: Those colors are used also in SCSS (app/assets/stylesheets/supporter-app/variables/_colors.scss)
// If you change something here, you need to change it in SCSS as well
import tinycolor from 'tinycolor2';
const getColorAlpha = (minAlpha, maxAlpha, referenceColorBrightness) => {
    return maxAlpha - ((maxAlpha - minAlpha) * referenceColorBrightness) / 255;
};
const colorPrimary = getComputedStyle(document.documentElement).getPropertyValue('--color-primary');
const colorOnPrimary = getComputedStyle(document.documentElement).getPropertyValue('--color-on-primary');
const colorBackground = getComputedStyle(document.documentElement).getPropertyValue('--color-background');
const colorOnBackground = getComputedStyle(document.documentElement).getPropertyValue('--color-on-background');
const colorOnBackgroundRgb = getComputedStyle(document.documentElement).getPropertyValue('--color-on-background-rgb');
const colorBackgroundBrightness = getComputedStyle(document.documentElement).getPropertyValue('--color-background-brightness');
const paleBackgroundAlpha = getColorAlpha(0.04, 0.1, parseInt(colorBackgroundBrightness));
const paleBorderAlpha = getColorAlpha(0.16, 0.2, parseInt(colorBackgroundBrightness));
export const colors = {
    background: colorBackground,
    onBackground: colorOnBackground,
    primary: colorPrimary,
    onPrimary: colorOnPrimary,
    pale: tinycolor(`rgba(${colorOnBackgroundRgb}, 0.1)`).toRgbString(),
    textPale: tinycolor(`rgba(${colorOnBackgroundRgb}, 0.6)`).toRgbString(),
    backgroundPale: tinycolor(`rgba(${colorOnBackgroundRgb}, ${paleBackgroundAlpha})`).toRgbString(),
    border: tinycolor(`rgba(${colorOnBackgroundRgb}, 0.3)`).toRgbString(),
    borderPale: tinycolor(`rgba(${colorOnBackgroundRgb}, ${paleBorderAlpha})`).toRgbString(),
};
